import { createRouter, createWebHashHistory } from 'vue-router'
import routerHandls from './router-guard'
import constantRoutes from './routes'
import { Page } from './router-enum'

export * from './router-enum'

const router = createRouter({
  history: createWebHashHistory(''),
  routes: [
    ...constantRoutes,
    {
      name: '顶部导航',
      path: Page.ACCOUNT_CENTER,
      component: () => import('views/AccountCenter/AccountCenterPage.vue'),
      children: [
        {
          name: '账号信息',
          path: Page.ACCOUNT_INFO,
          component: () => import('views/AccountCenter/account-info/index.vue'),
        },
        {
          name: '修改手机号',
          path: Page.RESET_MOBILE,
          component: () => import('views/AccountCenter/ResetMobile/index.vue'),
        },
        {
          name: '人工申诉',
          path: Page.RESET_MOBILE_APEAL,
          component: () => import('views/AccountCenter/appeal/index.vue'),
        },
        {
          name: '重置密码',
          path: Page.RESET_PWD,
          component: () =>
            import('views/AccountCenter/ResetPassword/ResetPasswordPage.vue'),
        },
        {
          name: '员工列表',
          path: Page.STAFF_LIST,
          component: () =>
            import('views/AccountCenter/StaffList/StaffListPage.vue'),
        },
        {
          name: '员工信息',
          path: Page.STAFF_LIST_EDIT_STAFF,
          component: () =>
            import('views/AccountCenter/StaffList/modules/StaffEdit.vue'),
        },
        {
          name: '安全中心',
          path: Page.SECURITY_CENTER,
          component: () =>
            import('views/AccountCenter/SecurityCenter/SecurityCenterPage.vue'),
        },
        // {
        //   name: '风险列表',
        //   path: Page.SECURITY_CENTER_RISKLIST,
        //   component: () =>
        //     import(
        //       'views/AccountCenter/SecurityCenter/components/SecurityCenterRiskList.vue'
        //     ),
        // },
        {
          name: '日志查看',
          path: Page.SECURITY_CENTER_LOGINLOG,
          component: () =>
            import(
              'views/AccountCenter/SecurityCenter/components/SecurityCenterLog.vue'
            ),
        },
        // {
        //   // name: '黑白名单设置',
        //   name: '名单设置',
        //   path: Page.SECURITY_CENTER_RISKIPOPERATION,
        //   component: () =>
        //     import(
        //       'views/AccountCenter/SecurityCenter/components/SecurityIpOperation.vue'
        //     ),
        // },
        {
          name: '强制下线',
          path: Page.SECURITY_FORCE_OFFLINE,
          component: () =>
            import(
              'views/AccountCenter/SecurityCenter/force-offline/index.vue'
            ),
        },
        // {
        //   name: '三方授权',
        //   path: Page.SECURITY_THIRDPART_AUTHORIZATION,
        //   component: () =>
        //     import(
        //       'views/AccountCenter/SecurityCenter/third-party/authorization.vue'
        //     ),
        // },
        // {
        //   name: '三方绑定管理',
        //   path: Page.SECURITY_THIRDPART_BIND,
        //   component: () =>
        //     import('@/views/AccountCenter/SecurityCenter/third-party/info.vue'),
        // },
      ],
    },

    {
        path: "/mini/staff",
        component: () => import("views/AccountCenter/StaffList/modules/StaffEdit.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return new Promise((resolve) => {
        if (from.meta.saveSrollTop) {
          const top: number =
            document.documentElement.scrollTop || document.body.scrollTop
          setTimeout(() => {
            resolve({ left: 0, top })
          }, 500)
        }
      })
    }
  },
})

// 路由操作
routerHandls(router)

export default router
